import { useTranslation } from 'react-i18next';

import { IntSummaryStatistics } from '../modules/generated/api';

import Co2Icon from './Co2Icon';
import IconValue from './IconValue';
import PackageDetailMinMaxRows from './PackageDetailMinMaxRows';
import UnitValue from './UnitValue';

type PackageDetailTileCo2Props = {
  engineCo2?: IntSummaryStatistics;
  standard?: 'WLTP' | 'NEDC';
};

const PackageDetailTileCo2 = ({ engineCo2, standard }: PackageDetailTileCo2Props) => {
  const { t } = useTranslation();
  const label = standard
    ? `${t('car.co2')} (${t(standard === 'WLTP' ? 'carsTable.co2TestingMethod.wltp' : 'carsTable.co2TestingMethod.nedc')})`
    : t('car.co2');

  return (
    <IconValue icon={Co2Icon} label={label} padding>
      <PackageDetailMinMaxRows
        min={<UnitValue value={engineCo2?.min} unit="g/km" />}
        avg={<UnitValue value={engineCo2?.average != null ? Math.round(engineCo2.average) : undefined} unit="g/km" />}
        max={<UnitValue value={engineCo2?.max} unit="g/km" />}
      />
    </IconValue>
  );
};

export default PackageDetailTileCo2;
